import { render, staticRenderFns } from "./LoaderProcess.vue?vue&type=template&id=23b1ac1d&scoped=true&"
import script from "./LoaderProcess.vue?vue&type=script&lang=js&"
export * from "./LoaderProcess.vue?vue&type=script&lang=js&"
import style0 from "./LoaderProcess.vue?vue&type=style&index=0&id=23b1ac1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b1ac1d",
  null
  
)

export default component.exports